import { Grid, makeStyles, MenuItem } from "@material-ui/core";
import { useTranslation } from "react-i18next";

import QCXFormStepWizard from "../../shared-components/form-step-wizard/QCXFormStepWizard";
import QCXSelectClienteAutocomplete from "../../shared-components/final-select-cliente-field/QCXSelectClienteAutocomplete";
import QCXSelectPortoAeroportoLocalDestinoAutocomplete from "../../shared-components/select-porto-aeroporto/QCXSelectPortoAeroportoLocalDestinoAutocomplete";
import QCXFinalTextField from "../../shared-components/final-text-field/QCXFinalTextField";
import QCXSelectPortoAeroportoLocalOrigemAutocomplete from "../../shared-components/select-porto-aeroporto/QCXSelectPortoAeroportoLocalOrigemAutocomplete";
import QCXSelectTransportadorInternacionalAutocomplete from "../../shared-components/select-transportador-internacional/QCXSelectTransportadorInternacionalAutocomplete";
import QCXSelectEmpresaEstrangeiraAutocompleteAutoLoad from "../../shared-components/final-select-empresa-estrangeira-field/QCXSelectEmpresaEstrangeiraAutocompleteAutoLoad";
import QCXFinalSelectGenericoAutocomplete from "../../shared-components/select-tipo-frete/QCXFinalSelectGenericoAutocomplete";

const useStyles = makeStyles(() => ({
    gridFields: {
        paddingBottom: '16px',
    },
}));

export default function QCXMasterForm({
    initialValues,
    handleSubmit,
    isConsult,
    isUpdate,
    controlComponentProps,
    authInfo = {},
    tipoFrete,
    setTipoFrete,
    requiredRoles = [],
}) {

    const { t } = useTranslation();

    const classes = useStyles();

    const handleTipoFreteChange = (event) => {
        setTipoFrete(event.target.value);
    };

    return (
        <QCXFormStepWizard
            initialValues={initialValues}
            onSubmit={handleSubmit}
            controlComponentProps={controlComponentProps}
            onChangeListeners={undefined}
            authInfo={authInfo}
            requiredRoles={requiredRoles}
        >
            {
                ({ values }) => (
                    <>
                        <Grid container spacing={2} style={{ 'marginTop': '10px' }} xs={12} sm={12} md={12}>
                            <Grid item xs={12} sm={4} md={4} lg={4} >
                                <QCXFinalTextField
                                    id="text-field-code"
                                    key="text-field-code"
                                    name="numeroMaster"
                                    label="Número do master"
                                    initialValues={values}
                                    disabled={isConsult}
                                    required
                                />
                            </Grid>
                        </Grid>

                        <Grid container spacing={2} style={{ 'marginTop': '10px' }} xs={12} sm={12} md={12}>
                            <Grid item xs={12} sm={6} md={6} >
                                <QCXSelectClienteAutocomplete
                                    id="autocomplete-select-consignatario-field"
                                    key="autocomplete-select-consignatario-field"
                                    name="consignatario.id"
                                    label="Consigatário"
                                    initialValues={values}
                                    disabled={isConsult}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} >
                                <QCXSelectEmpresaEstrangeiraAutocompleteAutoLoad
                                    id="autocomplete-select-exportador-field"
                                    key="autocomplete-select-exportador-field"
                                    name="exportador.id"
                                    label="Exportador"
                                    initialValues={values}
                                    disabled={isConsult}
                                    required
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} style={{ 'marginTop': '10px' }} xs={12} sm={12} md={12}>
                            <Grid item xs={12} sm={4} md={4} lg={4}>
                                <QCXSelectTransportadorInternacionalAutocomplete
                                    id="autocomplete-select-origem-field"
                                    key="autocomplete-select-origem-field"
                                    name="transportadorInternacional"
                                    label="Cia aérea"
                                    agenteTransportador={false}
                                    initialValues={values}
                                    disabled={isConsult}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} sm={3} md={3} lg={3}>
                                <QCXSelectPortoAeroportoLocalOrigemAutocomplete
                                    id="autocomplete-select-origem-field"
                                    key="autocomplete-select-origem-field"
                                    name="origem.id"
                                    label={t('com.muralis.qcx.agenciamento.origem')}
                                    initialValues={values}
                                    disabled={isConsult}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} sm={3} md={3} lg={3}>
                                <QCXSelectPortoAeroportoLocalDestinoAutocomplete
                                    id="autocomplete-select-destino-field"
                                    key="autocomplete-select-destino-field"
                                    name="destino.id"
                                    label={t('com.muralis.qcx.agenciamento.destino')}
                                    initialValues={values}
                                    disabled={isConsult}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} sm={2} md={2} lg={2}>
                                <QCXFinalSelectGenericoAutocomplete
                                    id="tipo-pagamento-field"
                                    key="tipo-pagamento-field"
                                    name="tipoPagamento"
                                    label="Tipo de Frete"
                                    initialValues={values}
                                    optionsProp={[{ label: 'Prepaid', value: 'PREPAID' },
                                    { label: 'Collect', value: 'COLLECT' }]}
                                    fieldProps={{ validate: undefined }}
                                    disabled={isConsult}
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} style={{ 'marginTop': '10px' }} xs={12} sm={12} md={12}>
                            <Grid item xs={12} sm={2} md={2}>
                                <QCXFinalSelectGenericoAutocomplete
                                    id="autocomplete-select-destino-field"
                                    key="autocomplete-select-destino-field"
                                    name="tipoEmbarque"
                                    label="Tipo Embarque"
                                    optionsProp={[{ label: 'Back to Back', value: 'BACK_TO_BACK' },
                                    { label: 'Consolidado', value: 'CONSOLIDADO' }]}
                                    initialValues={values}
                                    disabled={isConsult}
                                    required
                                />
                            </Grid>
                        </Grid>


                    </>
                )
            }
        </QCXFormStepWizard>
    );

}